import React, { useState, useEffect } from "react";
import PageShell from "../dashboard/PageShell";
import {
  ProjectBasicInfo,
  ProjectMembers,
  ProjectAdditionalContent,
  ProjectFormActions,
} from "../../components/forms/ProjectForm";
import RichTextEditor from "../../components/forms/RichTextEditor";

const EditOngoingProject: React.FC = () => {
  const [activeTab, setActiveTab] = useState("topic-info");
  const [formData, setFormData] = useState({
    topicName: "",
    managementLevel: "",
    managementLevelInput: "",
    provinceCity: "",
    researchField: "",
    specificProgram: "",
    proposedBudget: "",
    leadUnit: "",
    leadUnitInput: "",
    governingUnit: "",
    otherGoverningUnit: "",
    startMonth: "",
    startYear: "",
    endMonth: "",
    endYear: "",
    contractingMethod: "",
    topicChair: "",
    chairName: "",
    chairGender: "",
    chairAcademicTitle: "",
    chairAcademicDegree: "",
    chairResearchTitle: "",
    chairRank: "",
    chairWorkUnit: "",
    topicSecretary: "",
    secretaryName: "",
    secretaryGender: "",
    secretaryAcademicTitle: "",
    secretaryAcademicDegree: "",
    secretaryResearchTitle: "",
    secretaryRank: "",
    secretaryWorkUnit: "",
    objective: "",
    topicType: "",
    urgencyAndNovelty: "",
    mainContents: "",
    applicationCapability: "",
    expectedBenefits: "",
    expectedResults: "",
    topicStatus: "",
    extensionCount: "",
    delayReason: "",
    members: [
      {
        id: 1,
        fullName: "",
        phone: "",
        email: "",
        unit: "",
        position: "",
        role: "",
        work: "",
      },
    ],
    additionalContent: "",
  });

  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleMemberChange = (index: number, field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      members: prev.members.map((member, i) =>
        i === index ? { ...member, [field]: value } : member
      ),
    }));
  };

  const addMember = () => {
    setFormData((prev) => ({
      ...prev,
      members: [
        ...prev.members,
        {
          id: prev.members.length + 1,
          fullName: "",
          phone: "",
          email: "",
          unit: "",
          position: "",
          role: "",
          work: "",
        },
      ],
    }));
  };

  const removeMember = (index: number) => {
    setFormData((prev) => ({
      ...prev,
      members: prev.members.filter((_, i) => i !== index),
    }));
  };

  const handleSave = () => {
    console.log("Saving project data:", formData);
    // TODO: Implement save functionality
  };

  const handleCancel = () => {
    window.history.back();
  };

  useEffect(() => {
    // Load existing project data
    setFormData((prev) => ({
      ...prev,
      topicName: "Nghiên cứu phần mềm quản lý KHCN có ứng dụng AI",
      managementLevel: "Cấp Viện/ Chi nhánh",
      provinceCity: "Hà Nội",
      researchField: "Công nghệ thông tin và tự động hóa",
      proposedBudget: "10.000.000.000 đ (10 tỷ)",
      leadUnit: "Trung tâm Đào tạo và Hợp tác Quốc tế",
      startMonth: "12",
      startYear: "2025",
      endMonth: "12",
      endYear: "2025",
      topicChair: "Thượng tá, VS. ThS Lê Anh Tuấn",
      topicSecretary: "Thượng tá, GS. TS Nguyễn Thị Hạnh",
      objective:
        "Xây dựng phần mềm phục vụ quản trị KHCN tại đơn vị gồm 1000 nghiên cứu viên",
      topicType: "Đề tài",
      urgencyAndNovelty: "Mới",
      mainContents:
        "Phần mềm triển khai trong toàn đơn vị với dự kiến 25 đề tài/năm",
      applicationCapability: "Ứng dụng cấp đơn vị",
      expectedBenefits: "Lợi ích dự kiến",
      expectedResults: "Ứng dụng cho mạng lưới",
      topicStatus: "Đang triển khai",
      extensionCount: "0",
      delayReason: "",
      members: [
        {
          id: 1,
          fullName: "Thượng tá, VS. ThS Lê Anh Tuấn",
          phone: "0988662866",
          email: "tuan@vnet.vn",
          unit: "Viện Nước, Tưới Tiêu và Môi trường",
          position: "Chủ nhiệm đề tài",
          role: "Chủ nhiệm",
          work: "Quản lý tổng thể đề tài",
        },
      ],
      additionalContent: "",
    }));
  }, []);

  return (
    <PageShell title="Sửa đề tài đang triển khai">
      <div className="space-y-6">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Sửa đề tài đang triển khai
          </h1>
        </div>

        {/* Tabs Section */}
        <div className="bg-white rounded-lg">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8 px-6">
              <button
                onClick={() => setActiveTab("topic-info")}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === "topic-info"
                    ? "border-[#337ab7] text-[#337ab7]"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                Thông tin đề tài
              </button>
              <button
                onClick={() => setActiveTab("full-content")}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === "full-content"
                    ? "border-[#337ab7] text-[#337ab7]"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                Nội dung đầy đủ
              </button>
            </nav>
          </div>

          {/* Tab Content */}
          <div className="p-6">
            {activeTab === "topic-info" && (
              <div className="space-y-8">
                {/* Top Field - Full Width */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Tên đề tài <span className="text-red-500">(*)</span>
                  </label>
                  <input
                    type="text"
                    value={formData.topicName}
                    onChange={(e) =>
                      handleInputChange("topicName", e.target.value)
                    }
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Nhập tên đề tài..."
                  />
                </div>

                <ProjectBasicInfo
                  formData={formData}
                  handleInputChange={handleInputChange}
                />

                <ProjectMembers
                  formData={formData}
                  handleInputChange={handleInputChange}
                />

                <ProjectAdditionalContent
                  formData={formData}
                  handleInputChange={handleInputChange}
                />

                {/* Extension and Delay Information */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Số lần gia hạn
                    </label>
                    <input
                      type="number"
                      value={formData.extensionCount}
                      onChange={(e) =>
                        handleInputChange("extensionCount", e.target.value)
                      }
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Nhập số lần gia hạn"
                      min="0"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Lý do chậm tiến độ
                    </label>
                    <textarea
                      value={formData.delayReason}
                      onChange={(e) =>
                        handleInputChange("delayReason", e.target.value)
                      }
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Nhập lý do chậm tiến độ (nếu có)"
                      rows={1}
                    />
                  </div>
                </div>
              </div>
            )}

            {activeTab === "full-content" && (
              <div className="space-y-8">
                {/* Rich Text Editor Section */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Kết quả dự kiến:
                  </label>
                  <RichTextEditor
                    value={formData.expectedResults || ""}
                    onChange={(value: string) =>
                      handleInputChange("expectedResults", value)
                    }
                    placeholder="Nhập nội dung kết quả dự kiến..."
                    height="large"
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <ProjectFormActions onSave={handleSave} onCancel={handleCancel} />
      </div>
    </PageShell>
  );
};

export default EditOngoingProject;
